import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Kickstart je dag met een lach: Drie gezonde ontbijtrecepten
                </title>
                <link rel="canonical" href={route("blogs.fifty-eight")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Goedemorgen, zonnestraaltjes! Het is weer een prachtige dag om je smaakpapillen te verwennen en je lichaam te voeden met wat oh-zo-nodige energie. Want laten we eerlijk zijn, het ontbijt is als de startknop van je innerlijke motor. En we willen natuurlijk geen startproblemen, toch? Dus, zet je schrap voor drie gezonde ontbijtrecepten die je dag zullen kickstarten met een lach!"
                />
                <meta
                    property="og:description"
                    content="Goedemorgen, zonnestraaltjes! Het is weer een prachtige dag om je smaakpapillen te verwennen en je lichaam te voeden met wat oh-zo-nodige energie. Want laten we eerlijk zijn, het ontbijt is als de startknop van je innerlijke motor. En we willen natuurlijk geen startproblemen, toch? Dus, zet je schrap voor drie gezonde ontbijtrecepten die je dag zullen kickstarten met een lach!"
                />
                <meta property="og:url" content={route("blogs.fifty-eight")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Kickstart je dag met een lach: Drie gezonde ontbijtrecepten - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/kickstart-ontbijt.png"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/kickstart-ontbijt.webp"
                                    type="image/webp"
                                    alt="Ontbijt"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/kickstart-ontbijt.png"
                                    type="image/jpeg"
                                    alt="Ontbijt"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/kickstart-ontbijt.png"
                                    alt="Ontbijt"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Kickstart je dag met een lach: Drie gezonde
                        ontbijtrecepten
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Goedemorgen, zonnestraaltjes! Het is weer een prachtige
                        dag om je smaakpapillen te verwennen en je lichaam te
                        voeden met wat oh-zo-nodige energie. Want laten we
                        eerlijk zijn, het ontbijt is als de startknop van je
                        innerlijke motor. En we willen natuurlijk geen
                        startproblemen, toch? Dus, zet je schrap voor drie
                        gezonde ontbijtrecepten die je dag zullen kickstarten
                        met een lach!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. De Smooth Operator: Groene Smoothie Bowl
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Vergeet die saaie{" "}
                        <a
                            href={route("blogs.thirty-eight")}
                            className="text-we-are-yellow"
                        >
                            groene smoothies
                        </a>{" "}
                        die smaken alsof je een gazon aan het drinken bent. Ik
                        introduceer je de Groene Smoothie Bowl, een kunstwerkje
                        dat niet alleen Instagram-waardig is, maar ook je tong
                        zal strelen als een fluwelen handschoen.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat heb je nodig
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>
                            Een handjevol verse spinazie (want ijzer is fijn)
                        </li>
                        <li>Een rijpe banaan (voor de zoete touch)</li>
                        <li>
                            Een handjevol bevroren mango (voor de tropische
                            twist)
                        </li>
                        <li>
                            Een scheutje amandelmelk (of een andere plantaardige
                            melk naar keuze)
                        </li>
                        <li>
                            Een snufje chiazaad (want chiazaad is het zwarte
                            goud)
                        </li>
                        <li>Een paar amandelen (voor de crunch)</li>
                        <li>
                            Vers fruit naar keuze (omdat we van kleur houden)
                        </li>
                    </ul>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe maak je het
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-decimal">
                        <li>
                            Gooi de spinazie, banaan, mango en amandelmelk in
                            een blender. Blend tot een gladde substantie.
                        </li>
                        <li>Schenk de smoothie in een kom.</li>
                        <li>
                            Strooi er wat chiazaad, amandelen en vers fruit
                            overheen.
                        </li>
                        <li>
                            Neem een foto voor je sociale media (optioneel, maar
                            sterk aanbevolen).
                        </li>
                        <li>Eet het op met een grote glimlach.</li>
                    </ul>
                    {/*  */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. De Eiwitkampioen: Omelet met een Twist
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Een ei hoort erbij, zeggen ze altijd. Maar we gaan niet
                        voor een simpel{" "}
                        <a
                            href={route("blogs.forty-one")}
                            className="text-we-are-yellow"
                        >
                            gekookt eitje
                        </a>
                        . Nee, we maken een omelet die zo vol zit met goodies
                        dat je bijna zou denken dat het je verjaardag is.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat heb je nodig:
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>2 eieren (kakelvers)</li>
                        <li>
                            Een handjevol spinazie (ja, alweer, want groen is
                            goed)
                        </li>
                        <li>Een paar cherrytomaatjes (voor de zoetigheid)</li>
                        <li>Een beetje feta (voor de pit)</li>
                        <li>Een snufje peper en zout (want smaak)</li>
                        <li>
                            Een scheutje olijfolie (voor de Mediterrane flair)
                        </li>
                    </ul>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe maak je het:
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-decimal">
                        <li>
                            Kluts de{" "}
                            <a
                                href={route("blogs.third")}
                                className="text-we-are-yellow"
                            >
                                eieren
                            </a>{" "}
                            in een kom en voeg peper en zout toe.
                        </li>
                        <li>
                            Verhit de olijfolie in een koekenpan en voeg de
                            spinazie toe tot deze geslonken is.
                        </li>
                        <li>
                            Giet de eieren erover en verdeel de cherrytomaatjes
                            en feta over de omelet.
                        </li>
                        <li>
                            Bak tot de eieren gestold zijn en de onderkant
                            goudbruin is.
                        </li>
                        <li>
                            Vouw de omelet dubbel en serveer met een knipoog.
                        </li>
                    </ul>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. De Zoetekauw's Delight: Havermout met Appel en Kaneel
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor degenen die 's ochtends een zoetekauw zijn, maar
                        toch gezond willen doen: maak kennis met je nieuwe beste
                        vriend, de Havermout met Appel en Kaneel. Het is als een
                        knuffel in een kom, en wie wil er nou niet geknuffeld
                        worden in de ochtend?
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat heb je nodig
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-disc">
                        <li>Een half kopje havermout (voor de vezels)</li>
                        <li>
                            Een kopje melk of plantaardige melk (voor de
                            smeuïgheid)
                        </li>
                        <li>Een appel (voor de frisheid)</li>
                        <li>Een snufje kaneel (voor de warmte)</li>
                        <li>
                            Een beetje honing of ahornsiroop (voor de liefde)
                        </li>
                    </ul>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe maak je het
                    </h3>
                    <ul className="mt-4 text-gray-100 break-words list-decimal">
                        {/* 1. Doe de havermout en melk in een pan en breng aan de
                        kook. 2. Laat het zachtjes koken tot de havermout de
                        melk heeft opgenomen. 3. Snijd ondertussen de appel in
                        kleine blokjes. 4. Voeg de appel en kaneel toe aan de
                        havermout en kook nog een paar minuten. 5. Schenk de
                        havermout in een kom en drizzle er wat honing of
                        ahornsiroop overheen. 6. Geniet ervan terwijl je jezelf
                        een schouderklopje geeft voor zo'n gezonde keuze. */}
                        <li>
                            Doe de havermout en melk in een pan en breng aan de
                            kook.
                        </li>
                        <li>
                            Laat het zachtjes koken tot de havermout de melk
                            heeft opgenomen.
                        </li>
                        <li>Snijd ondertussen de appel in kleine blokjes.</li>
                        <li>
                            Voeg de appel en kaneel toe aan de havermout en kook
                            nog een paar minuten.
                        </li>
                        <li>
                            Schenk de havermout in een kom en drizzle er wat
                            honing of ahornsiroop overheen.
                        </li>
                        <li>
                            Geniet ervan terwijl je jezelf een schouderklopje
                            geeft voor zo'n gezonde keuze.
                        </li>
                    </ul>
                    {/*  */}
                    <p className="mt-4 text-gray-100 break-words">
                        Zo, nu ben je klaar om de dag te veroveren met een volle
                        buik en een glimlach op je gezicht. Of je nu een
                        smoothie bowl artiest, een omeletfluisteraar of een
                        havermoutgoochelaar bent, met deze recepten zet je niet
                        alleen een heerlijk ontbijt op tafel, maar ook een
                        gezonde dosis humor. Eet smakelijk en vergeet niet: een
                        dag niet gelachen is een dag niet ontbeten!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
